export default class EmailMetricDomainService {
    static emailMetricsForSourceFromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), startedDate: json.startedDate && new Date(json.startedDate) });
    }
    static createEmptyForSource(id) {
        return {
            openCount: 0,
            clickCount: 0,
            deliveryCount: 0,
            bounceCount: 0,
            sentCount: 0,
            uniqueOpens: 0,
            uniqueClicks: 0,
            clickRate: 0,
            clickThroughRate: 0,
            bounceRate: 0,
            deliveredRate: 0,
            openRate: 0,
            sourceIntId: typeof id === "number" ? id : null,
            sourceUuidId: typeof id === "string" ? id : null,
            name: "",
            createdDate: new Date(0),
            startedDate: new Date(0),
            createdByAffiliationId: "",
            createdByFullName: "",
        };
    }
    static createEmptyAggregate() {
        return {
            openCount: 0,
            clickCount: 0,
            deliveryCount: 0,
            bounceCount: 0,
            sentCount: 0,
            uniqueOpens: 0,
            uniqueClicks: 0,
            clickRate: 0,
            clickThroughRate: 0,
            bounceRate: 0,
            deliveredRate: 0,
            openRate: 0,
            numSources: 0,
        };
    }
    static aggregatedByDayEmailMetricFromJSON(json) {
        return Object.assign(Object.assign({}, json), { periodStart: new Date(json.periodStart) });
    }
}
